import React from 'react';
import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';
import { createSelector, createStructuredSelector } from 'reselect';

import {
  clearCityBikes,
  getCityBikes,
  clearStaticPage,
  loadStaticPage,
  loadStaticPages
} from 'actions';
import {
  bikeTypesSelector,
  cityBikesDataSelector,
  countriesSelector,
  currencySelector,
  staticPageCitySelector,
  staticPageCountrySelector,
  staticPageErrorSelector,
  staticPageFetchingSelector,
  staticPageSelector,
  staticPagesSelector
} from 'selectors';
import {
  createPromise,
  isPromise
} from 'utils';

import NotFoundPage from '../NotFoundPage';
import StaticCityPage from './StaticCityPage';

const NotFoundWrapper = (props) => {
  if (props.error) {
    return <NotFoundPage {...props} />;
  }

  return <StaticCityPage {...props} />;
};

const filteredStaticPagesSelector = createSelector(
  staticPageSelector,
  staticPagesSelector,
  (data, list) => {
    if (!data || !list) {
      return [];
    }

    return list.filter((item) => item.url !== data.url);
  }
);

const mapStateToProps = createStructuredSelector({
  isFetching: staticPageFetchingSelector,
  data: staticPageSelector,
  error: staticPageErrorSelector,
  city: staticPageCitySelector,
  cityBikes: cityBikesDataSelector,
  country: staticPageCountrySelector,
  countries: countriesSelector,
  currency: currencySelector,
  bikeTypes: bikeTypesSelector,
  staticPages: filteredStaticPagesSelector
});

const mapDispatchToProps = {
  clearCityBikes,
  clearStaticPage
};

const promises = [{
  promise: ({
    store,
    params: { splat: slug }
  }) => {
    const loadCityBikes = () => {
      const staticPage = staticPageSelector(store.getState());

      if (!staticPage) {
        return Promise.resolve();
      }

      const country = staticPageCountrySelector(store.getState());

      const queryParams = {
        country: country ? country.id : null,
        pickUpCity: staticPage.city ? staticPage.city.id : null,
        dropOfCity: staticPage.city ? staticPage.city.id : null,
        bikeTypes: staticPage.searchBikeType,
        returnAtSameCity: true,
        extras: null
      };

      return store.dispatch(getCityBikes(queryParams));
    };

    const getStaticPages = () => {
      const staticPage = staticPageSelector(store.getState());

      if (!staticPage) {
        return Promise.resolve();
      }

      return store.dispatch(loadStaticPages({
        search_city: staticPage.city ? staticPage.city.id : null
      }));
    };

    const checkSelector = createSelector(
      staticPageSelector,
      (staticPage) => staticPage && (staticPage.url === slug)
    );

    let promise = createPromise(store, true, checkSelector, loadStaticPage, slug);

    if (!isPromise(promise)) {
      promise = getStaticPages();
    } else {
      promise = promise.then(getStaticPages);
    }

    promise = promise.then(loadCityBikes);

    return promise;
  }
}];

export default asyncConnect(
  promises,
  mapStateToProps,
  mapDispatchToProps
)(translate(['translation'])(NotFoundWrapper));



// WEBPACK FOOTER //
// ./src/components/StaticCityPage/index.js